export default "__VITE_ASSET__e1936cc0__"